import React, {useEffect, useState} from "react";
import {RoadMapService} from "../../../services/cp/RoadMapService";
import {toast} from "react-toastify";
import {ActvScopService} from "../../../services/cp/ActvScopService";
import {ExistCpDataConstant} from "../../../constants/cpConstant";
import DashboardNoData from "./DashboardNoData";
import DashboardLoading from "./DashboardLoading";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";
import {RdcType} from "../../../model/cp/Roadmap";
import dayjs from "dayjs";

const currentYear: number = dayjs().year();
export default function RdcGoal(props: Readonly<DashboardModuleProps>) {
  const [existRdcGoalSetting, setExistRdcGoalSetting] = useState<any>(null);
  const [roadmapData, setRoadmapData] = useState<RdcType>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        const response = await ActvScopService.getInstance().existCpData([ExistCpDataConstant.G, ExistCpDataConstant.S]);
        if (response && response.resultCode === "Y") {
          if (response.data?.REDUCE_GOAL && response.data?.SETTING) {
            setExistRdcGoalSetting(true);
            await getChartData();
          }
        } else {
          toast.error("시스템 오류가 발생하였습니다.");
        }
      } catch (error) {
        toast.error("데이터 초기화 중 오류가 발생하였습니다.");
      } finally {
        setIsLoading(false);
      }
    };
    initialize();
  }, []);

  async function getChartData() {
    try {
      const response = await RoadMapService.getInstance().getRoadmap();
      if (response && response.resultCode === "Y") {
        if (response?.data) {
          const roadmapChartData = response.data;
          if (roadmapChartData && Object.keys(roadmapChartData).length > 0) {
            const strtYy = roadmapChartData.strtYy;
            const midYy  = roadmapChartData.midYy;
            const goalYy = roadmapChartData.goalYy;
            const midGoalRt = roadmapChartData.midGoalRt;
            const goalRt    = roadmapChartData.goalRt;

            const useMid = !!midYy && currentYear < Number(midYy);
            const targetYear = (useMid ? midYy : goalYy) || "-";
            const baseRate = useMid ? midGoalRt : goalRt;
            const targetRate = baseRate == null ? "-" : String(baseRate);

            setRoadmapData({
              strtYy,
              goalYy,
              midYy,
              midGoalRt,
              goalRt,
              targetYear,
              targetRate,
            });
          }
        }
      } else {
        toast.error("데이터를 불러오는 도중 오류가 발생하였습니다.");
      }
    } catch (e) {
      toast.error("시스템 오류가 발생하였습니다.");
    }
  }

  return (
    <DashboardCard
      title="감축목표"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/cp/roadmap/status"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      {!existRdcGoalSetting ? (
        <DashboardNoData
          message="탄소플래너 감축목표를 설정하세요."
          link={{text: '감축목표 설정하기', to: '/cp/roadmap/reduceGoal'}}
        />
      ) : (
        <div className="box-table2">
          <p className="tit"><strong>2050</strong>탄소중립</p>
          <div className="rd-goal">
            <p className="goal">
              <strong>{roadmapData?.targetYear ?? "-"}</strong>년까지{" "}
              <strong>{roadmapData?.targetRate ?? "-"}</strong>% 감축
            </p>
          </div>
          <div className="rd-list">
            <ul>
              <li><span>기준연도</span>
                <strong>{roadmapData?.strtYy ?? "-"}</strong>
              </li>
              <li>
                <span>중간목표연도</span>
                <strong>
                  <em>{roadmapData?.midGoalRt ?? "-"}%
                    <i className="xi-long-arrow-down" aria-hidden="true"/>
                  </em>
                  <strong>{roadmapData?.midYy ?? "-"}</strong>
                </strong>
              </li>
              <li>
                <span>최종목표연도</span>
                <strong>
                  <em>{roadmapData?.goalRt ?? "-"}%
                    <i className="xi-long-arrow-down" aria-hidden="true"></i>
                  </em>
                  {roadmapData?.goalYy ?? "-"}
                </strong>
              </li>
            </ul>
          </div>
        </div>
      )}
    </DashboardCard>
  )
}